<template>
    <div class="overflow-auto">
        <PageTop></PageTop>
        <!-- 题目 -->
        <div class="text-16 text-center bg-primary text-bg my-12 w-200 mx-auto">保岗：{{baogang}}</div>
        <div v-html="text" class="bg-bd text-14 text-center p-12 rounded-12 w-200 mx-auto shadow-[2px_2px_2px_#ccc]">
        </div>

        <!-- 直播区 -->
        <div 
        :class="{'animate-shake':anmi}"
        class="will-change-transform [backface-visibility:hidden] [transform:translateZ(0)]">
        <div class="bg-bd w-200 h-200 mt-12 mx-auto">
            <img class="block w-200 h-200" :src="`/images/${live.live || 'bg'}.png`" alt="">
            
        </div>
        <div class="text-bg bg-primary mx-auto text-18 w-200 text-center border-2 border-solid border-bd">
                {{ imgName[live.live - 1] }}
            </div>
        <div>
        </div>
        </div>
        <!-- 倒计时与历史 -->
        <div class="text-center">
            {{ timeName }}:{{ time }}
        </div>
        <div class="border-2 text-16 border-solid border-bd w-300 overflow-hidden my-12 mx-auto">
            <div class="flex justify-around w-300 bg-primary text-bg">
                <div class="text-center">第一场 12:00</div>
                <div class="text-center">第二场 20:00</div>
            </div>
            <div class="flex justify-around w-300 bg-bg text-primary">
                <div>
                    {{ imgName?.[live.liveHistory?.[0]?.result - 1] || '未开奖' }}
                </div>
                <div>
                    {{ imgName?.[live.liveHistory?.[1]?.result - 1] || '未开奖' }}
                </div>
            </div>
        </div>
        <div v-if="isWin" class='w-300 text-center text-16 p-4 border-2 border-solid border-bd bg-bg fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-[2px_2px_2px_#ccc]'>
            <div>
                <div>【开奖】</div>
                <img class="block mx-auto w-100 h-100" :src="`/images/${live.live || 'bg'}.png`">
                {{ imgName[live.live - 1]}}
            </div>
        </div>
        <!-- 按钮 -->
        <div class="w-300 flex justify-around mx-auto">
            <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'history'})"
            >
                查看历史
            </button>
            <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'info'})"
            >
                查看玩法
            </button>
            <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="loubao"
            >
                漏宝
            </button>
            <button
            class="bg-bd text-14 px-4 py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="$router.push({name:'download'})"
            >
                下载
            </button>
        </div>
        <!-- 弹窗 -->
        <div v-if="loubaoStatus">
            <div class="w-300 text-16 p-4 border-2 border-solid border-bd bg-bg absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" >
            <div v-html="loubaoText"></div>
            <button
            class="bg-bd text-14 px-4 mx-auto py-1 text-bg block shadow-[2px_2px_2px_#ccc]"
            @pointerup="loubaoStatus = false"
            >
                关闭
            </button>
            </div>
        </div>
    </div>
</template>
<script>
import PageTop from '@/components/PageTop.vue';
import moment from "moment-timezone";
export default{
    components:{
        PageTop,
    },
    data(){
        return{
            imgName: [
                '白鱼','白马','蝴蝶','金龙','野猫','和尚','鸡','金鱼','马鹿',
                '仙鹤','乌龟','乌鸦','大象','蜘蛛','蛇','孔雀','老虎','鹅',
                '红燕','猴子','猪','螺蛳','狗','兔子','飞龙','家猫','螃蟹',
                '牛','羊','蚯蚓','鸽子','青蛙','宝石','蜜蜂','黄鳝','老鼠'
            ],    
            flag:false,
            pho:0,
            baogang:'',
            timeName:'',
            time: "00:00:00",
            timer: null,
            text:'',
            loubaoText:'',
            loubaoStatus:false,
            timmer:'',
            isWin:false,
            isHave:false,
            anmi:false,
            live:{

            }
        }
    },
    mounted() {
        this.preloadImages()
        this.updateTime();
        this.timmer = setInterval(() => {
            this.getData()
        }, 2000);
    },

    beforeDestroy() {
        clearTimeout(this.timer);
        clearInterval(this.timmer)
    },
    methods:{
        loubao(){
            this.loubaoText = `${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}<br>${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}，${this.imgName[Math.floor(Math.random() * this.imgName.length)]}`
            this.loubaoStatus = true
        },
        async getData(){
            if(this.timeName === '即将开始下一场'){

                this.anmi = false
            }else{
                this.anmi = true
            }
            
            
            this.isHave = true
            this.flag = true
            try{
                const res = await this.$axios.get('/user/live')
                this.live=res.data.data
                this.flag = false
                this.text = this.formatTwoLines(res.data.data.ques.text)
                this.baogang = res.data.data.ques.baodi
                this.anmi = false
            }catch(err){
                console.error(err);
                
            }
        },
        preloadImages() {
            const promises = [];

            for (let i = 1; i <= 36; i++) {
                promises.push(
                new Promise((resolve) => {
                    const img = new Image();
                    img.src = `/images/${i}.png`;
                    img.onload = resolve;
                    img.onerror = resolve; // 防止卡死
                })
                );
            }

            Promise.all(promises).then(() => {
                this.imagesLoaded = true;
            });
        },
        formatTwoLines(text) {
        if (!text) return "";

        // 支持中英文逗号
        const parts = text.split(/，|,/).map(s => s.trim()).filter(Boolean);

        if (parts.length <= 1) {
            return `<span class="block text-14 text-center">${text}</span>`;
        }

        // 平均分两行
        const mid = Math.ceil(parts.length / 2);
        const line1 = parts.slice(0, mid).join("，");
        const line2 = parts.slice(mid).join("，");

        return `
            <span class="block">${line1}</span>
            <span class="block">${line2}</span>
        `;
        },
         getTargetTime() {
            const now = moment().tz("Asia/Yangon");
            const hour = now.hour();
            const timeStr = now.format("HH:mm:ss");
            // 判断函数
            function isInRange(start, end) {
            return timeStr >= start && timeStr <= end;
            }

            // 两个时间段
            const inFirstRange = isInRange("12:00:00", "12:00:10");
            const inSecondRange = isInRange("20:00:01", "20:00:10");

            if (inFirstRange || inSecondRange) {
                localStorage.setItem('isWin',2)
                this.isWinw()
            } 
            if (hour < 12) {
                this.timeName = '开奖倒计时'
                return now.clone().hour(12).minute(0).second(0);
            }
            if (hour < 13){
                this.timeName = '即将开始下一场'
                return now.clone().hour(13).minute(0).second(0);
            } 
            if (hour < 20){
                this.timeName = '开奖倒计时'
                return now.clone().hour(20).minute(0).second(0);
            } 
            if (hour < 21){
                this.timeName = '即将开始下一场'
                return now.clone().hour(21).minute(0).second(0);
            } 
            
            this.timeName = '开奖倒计时'
            return now.clone().add(1, "day").hour(12).minute(0).second(0);
        },
        updateTime() {
        const now = moment().tz("Asia/Yangon");
        const target = this.getTargetTime();

        let diff = target.diff(now);

        if (diff <= 0) {
            this.time = "00:00:00";
            this.scheduleNextTick();
            return;
        }

        const duration = moment.duration(diff);

        const h = String(Math.floor(duration.asHours())).padStart(2, "0");
        const m = String(duration.minutes()).padStart(2, "0");
        const s = String(duration.seconds()).padStart(2, "0");

        this.time = `${h}:${m}:${s}`;

        this.scheduleNextTick();
        },
        scheduleNextTick() {
            const now = moment().tz("Asia/Yangon");

            // 距离下一秒的毫秒数（对齐系统时间）
            const delay = 1000 - now.milliseconds();

            this.timer = setTimeout(() => {
                this.updateTime();
            }, delay);
        },
        isWinw(){
            const isWin1 = Number(localStorage.getItem('isWin'))
            
            if(isWin1 === 1){
                return
            }else if(isWin1 === 2){
                this.isWin = true
                setTimeout(() => {
                    this.isWin = false
                    localStorage.setItem('isWin',1)
                }, 6000);
            }
        }
    }
}
</script>
<style scoped>

</style>